export enum ChatWritingStyle {
  DEFAULT = 'default',
  ARGUMENTATIVE = 'argumentative',
  CONVERSATIONAL = 'conversational',
  CREATIVE = 'creative',
  INFORMATIVE = 'informative',
  INSTRUCTIVE = 'instructive',
  TECHNICAL = 'technical',
}

export enum ChatDocumentLanguage {
  DA = 'da', // Danish
  DE = 'de', // German
  EN = 'en', // English
  ES = 'es', // Spanish
  FR = 'fr', // French
  IT = 'it', // Italian
  JA = 'ja', // Japanese
  KO = 'ko', // Korean
  NL = 'nl', // Dutch
  PL = 'pl', // Polish
  PT = 'pt', // Portuguese
  SL = 'sl', // Slovak
  SV = 'sv', // Swedish
  TR = 'tr', // Turkish
  ZH = 'zh', // Chinese
}

export type ChatSettings = {
  id: string;
  userToTeamId: number;
  entityId: string;
  temperature: number;
  writingStyle: ChatWritingStyle;
  documentLanguage: ChatDocumentLanguage;
  createdAt: Date;
  updatedAt: Date;
};
